import React, { useEffect } from 'react';
import { CheckCircle, XCircle, AlertTriangle, X } from 'lucide-react';

// --- Toast Notification Component ---
// Displays a temporary success, error, or warning message.
export function Toast({ message, onClear }) {
  
  // --- MODIFIED: Hook moved to the top ---
  // Hooks must be called in the same order on every render.
  useEffect(() => {
    // We put the conditional logic *inside* the hook
    if (message) {
      const timer = setTimeout(() => {
        onClear();
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [message, onClear]);
  // --- END MODIFIED ---

  // The conditional return now happens *after* all hooks have been called.
  if (!message) return null;

  const messageText = typeof message === 'string' ? message : (message.text || '');
  const type = typeof message === 'object' && message.type ? message.type : 'success';

  let Icon = CheckCircle;
  let colorClass = 'text-green-500';
  let borderClass = 'border-green-500';
  let title = 'Success!';

  if (type === 'error') {
      Icon = XCircle;
      colorClass = 'text-red-500';
      borderClass = 'border-red-500';
      title = 'System Error';
  } else if (type === 'warning') {
      Icon = AlertTriangle;
      colorClass = 'text-amber-500';
      borderClass = 'border-amber-500';
      title = 'System Alert';
  }

  return (
    <div className="fixed top-24 right-4 z-50 w-full max-w-sm animate-fade-in">
      <div className={`bg-white rounded-lg shadow-2xl p-4 border-l-4 ${borderClass}`}>
        <div className="flex items-start">
          <Icon className={`w-6 h-6 flex-shrink-0 mr-3 ${colorClass}`} />
          <div className="flex-1">
            <h4 className="font-bold text-gray-800">{title}</h4>
            <p className="text-gray-600">{messageText}</p>
          </div>
          <button onClick={onClear} className="ml-2 text-gray-400 hover:text-gray-600">
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
}